import { orderBy } from 'lodash';

import { Section, Subcategory } from '../models';

const HIDDEN_POLITICIAN_SECTION_NAMES = new Set([
  'Political Affiliations',
  'Charitable History',
  'Political Views',
  'Previous Positions Held',
  'Political Awards',
]);

/**
 * Limit new Politician profiles to the sections supported by the UI without
 * making legacy sections that already contain data impossible to edit.
 */
export function isPoliticianWizardSectionVisible(
  section: Section,
  subCategory?: Subcategory
): boolean {
  return (
    subCategory?.name !== 'Politician' ||
    !HIDDEN_POLITICIAN_SECTION_NAMES.has(section.name ?? '') ||
    hasSectionContent(section)
  );
}

function hasSectionContent(section: Section): boolean {
  return [section, ...(section.subSections ?? [])].some((item) =>
    (item.fields ?? []).some(
      (field) =>
        field.value !== '' && field.value !== null && field.value !== undefined
    )
  );
}

function getVisibleWizardSections(
  categorySections: readonly Section[],
  subCategories: readonly Subcategory[]
): Section[] {
  const orderedCategorySections = orderBy(
    categorySections,
    ['displayOrder'],
    ['asc']
  );
  const orderedSubCategories = orderBy(
    subCategories,
    ['displayOrder'],
    ['asc']
  );

  return [
    ...orderedCategorySections,
    ...orderedSubCategories.flatMap((subCategory) =>
      (subCategory.sections ?? []).filter((section) =>
        isPoliticianWizardSectionVisible(section, subCategory)
      )
    ),
  ];
}

export function getProfileWizardStepTotal(
  categorySections: readonly Section[],
  subCategories: readonly Subcategory[]
): number {
  return 1 + getVisibleWizardSections(categorySections, subCategories).length;
}

export function getProfileWizardStepNumber(
  targetSection: Section,
  categorySections: readonly Section[],
  subCategories: readonly Subcategory[]
): number {
  const sectionIndex = getVisibleWizardSections(
    categorySections,
    subCategories
  ).indexOf(targetSection);

  return sectionIndex === -1 ? 0 : sectionIndex + 2;
}
